export { default } from './new-cars-promo-banner'
